export default __webpack_public_path__ + "static/media/CL12.26943d16.mp3";